import gql from "graphql-tag";

export const DeleteMeeting = gql`
  mutation DeleteMeeting($id: String!) {
    deleteWorktableMeeting(worktableMeetingId: $id)
  }
`;
